import React from "react";
import ReactDOM from "react-dom/client";
import DefenceAudits from "./defence-audits";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <DefenceAudits />
  </React.StrictMode>,
);
